import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EASE } from '../../utils/motion';
type MechanismConnectorProps = {
  dimmed: boolean;
  showInhibitor: boolean;
  compact: boolean;
};
const dotDelays = ['0s', '-0.8s', '-1.6s'];
export function MechanismConnector({
  dimmed,
  showInhibitor,
  compact
}: MechanismConnectorProps) {
  return <div className={`relative bg-hairline ${compact ? 'my-2 ml-3 h-12 w-px' : 'mx-6 h-px flex-1'}`} aria-hidden="true" data-id="element-49" data-mp="1recr8qc3k7lq">
      {dotDelays.map(d => <span key={d} className={`absolute h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-ink transition-opacity duration-300 ease-out motion-reduce:hidden ${compact ? 'animate-travel-y' : 'animate-travel-x'} ${dimmed ? '!opacity-15' : ''}`} style={{
      animationDelay: d
    }} data-id="element-50" data-mp="215h5fnty7ofi" />)}
      <AnimatePresence data-id="element-51" data-mp="gqoy7p5sk3ym">
        {showInhibitor && <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-52" data-mp="gs8al4obtuv4">
            <motion.span initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.25,
          ease: EASE
        }} className={`block rounded-full bg-accent-fill ${compact ? 'h-1 w-12' : 'h-12 w-1'}`} data-id="element-53" data-mp="ccobv0fpvf0t" />
          </div>}
      </AnimatePresence>
    </div>;
}